import React, { Component } from "react"
import { Form, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Label, Button, Input, FormFeedback, Alert, Row, Col, Progress } from "reactstrap"
import Select from "react-select"
import moment from 'moment'
import { graphql } from '@apollo/client/react/hoc'
import { AllCarModels, AllAgreementTypes } from "./Queries"
import { CreatePromotionTemplateMutation } from './Mutations'
import toTitleCase from "../Functions/toTitleCase"
import withApolloClient from '../withApolloClient'


const IntervalOptions = [
    { value: 'Day', label: 'Day' },
    { value: 'Week', label: 'Week' },
    { value: 'Month', label: 'Month' },
]

const IsPercentageOptions = [
    { value: "true", label: "Percentage" },
    { value: "false", label: "Flat Price" },
]
class AddPromotionModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input: {
                title: null,
                promoPrice: null,
                minimumPromoPrice: null,
                maximumPromoPrice: null,
                cycle: null,
                minCycle: null,
                maxCycle: null,
                interval: 1,
                intervalUnit: '',
                carYearMin: null,
                carYearMax: null,
                visibleToCustomers: false,
                startDate: null,
                expirationDate: null,
                isPercentage: "false",
                carModels: null,
                tagNames: "",
            },
            createAnother: false,
            loading: false,
            error: "",
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let input = { ...this.state.input }

        if (input.tagNames && typeof input.tagNames === "string") {
            input.tagNames = input.tagNames.split(",").map(item => item.trim())
        }

        if (!input.promoPrice || !input.minimumPromoPrice || !input.maximumPromoPrice || !input.cycle || !input.minCycle || !input.maxCycle || !input.carModels || !input.agreementType || !input.intervalUnit || !input.startDate || !input.expirationDate) {
            this.setState({ loading: false, error: "Please provide all required fields, for creating a pricing template!" })
            return
        }

        try {
            input = {
                ...input, promoPrice: parseFloat(input.promoPrice),
                minimumPromoPrice: parseFloat(input.minimumPromoPrice), maximumPromoPrice: parseFloat(input.maximumPromoPrice),
                cycle: parseFloat(input.cycle), minCycle: parseFloat(input.minCycle),
                maxCycle: parseFloat(input.maxCycle), carYearMin: parseInt(input.carYearMin),
                carYearMax: parseInt(input.carYearMax),
                isPercentage: this.state.input.isPercentage === "true",
                interval: parseInt(input.interval),
                intervalUnit: input.intervalUnit.charAt(0).toUpperCase() + input.intervalUnit.substr(1).toLowerCase(),
            }

            this.setState({ loading: true })
            this.props.apolloClient.mutate({
                mutation: CreatePromotionTemplateMutation,
                variables: { input },
            }).then((result) => {
                if (result.data && result.data.createPromotionTemplate && result.data.createPromotionTemplate.ok) {
                    this.props.refetch()
                    this.props.toggleModal()
                    if (this.state.createAnother) {
                        setTimeout(() => {
                            this.props.toggleModal()
                        }, 200)
                    }
                    this.setState({ loading: false, error: "" })
                } else if (result.data && result.data.createPromotionTemplate && !result.data.createPromotionTemplate.ok && result.data.createPromotionTemplate.errors && result.data.createPromotionTemplate.errors[0]) {
                    this.setState({ loading: false, error: result.data.createPromotionTemplate.errors[0].messages.toString() })
                } else {
                    this.setState({ loading: false, error: "Something went wrong, please contact admin for support!" })
                }
            }).catch((err) => {
                this.setState({ loading: false, error: err.message })
            })
        } catch (err) {
            this.setState({ loading: false, error: err })
        }
    };

    handleChange = (e, number = false) => {
        if (e.target.type === "checkbox")
            this.setState({ input: { ...this.state.input, [e.target.name]: !this.state.input[e.target.name] } })
        else if (number) {
            this.setState({ input: { ...this.state.input, [e.target.name]: parseFloat(e.target.value) } })
        }
        else {
            this.setState({ input: { ...this.state.input, [e.target.name]: e.target.value } })
        }
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} className="bos-car-attr-modal" style={{ maxWidth: 800 }}>
                <ModalHeader> Add New Promotion </ModalHeader>
                <ModalBody>
                    {this.state.error && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                    {(this.state.loading || this.props.loading) && <Row><Col xs={12}><Progress animated color="info" value="100" /></Col></Row>}
                    <Row>
                        <Col>
                            <Label check>Is Percentage/Flat Promo ?</Label>
                            <Select
                                className="bos-custom-select"
                                classNamePrefix="bos-select"
                                options={IsPercentageOptions}
                                onChange={(selectedOption) => this.setState((prevState) => ({ input: { ...prevState.input, isPercentage: selectedOption.value }, }))}
                                value={IsPercentageOptions.find(option => option.value === this.state.input.isPercentage)}
                                placeholder="Select Percentage or Flat Promo"
                            />
                        </Col>
                    </Row>
                    <hr />
                    <Form onSubmit={this.handleSubmit}>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="templateTitle">Title</Label>
                                    <Input type="text" step="any" name="title" id="templateTitle" placeholder="Title" value={this.state.input.title} onChange={(e) => this.handleChange(e)} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templatePrice">Default Value {this.state.input.isPercentage === "true" ? "(%)" : "($)"} *</Label>
                                    <Input type="number" step="any" min="0" name="promoPrice" id="templatePrice" placeholder="$ Price" value={this.state.input.promoPrice} onChange={(e) => this.handleChange(e, true)} required />
                                </FormGroup>
                            </Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templateminimumPromoPrice">Minimum Value {this.state.input.isPercentage === "true" ? "(%)" : "($)"} *</Label>
                                    <Input valid={this.state.input.promoPrice && this.state.input.minimumPromoPrice && this.state.input.minimumPromoPrice < this.state.input.promoPrice}
                                        invalid={this.state.input.promoPrice && this.state.input.minimumPromoPrice && this.state.input.minimumPromoPrice > this.state.input.promoPrice}
                                        type="number" step="any" min="0" name="minimumPromoPrice" id="templateminimumPromoPrice" placeholder="$ Minimum Price"
                                        value={this.state.input.minimumPromoPrice} onChange={(e) => this.handleChange(e, true)} required />
                                    <FormFeedback>Minimum Price must be less than the default Price</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templatemaximumPromoPrice">Maximum Value {this.state.input.isPercentage === "true" ? "(%)" : "($)"} *</Label>
                                    <Input
                                        valid={this.state.input.promoPrice && this.state.input.maximumPromoPrice && this.state.input.maximumPromoPrice > this.state.input.promoPrice}
                                        invalid={this.state.input.promoPrice && this.state.input.maximumPromoPrice && this.state.input.maximumPromoPrice < this.state.input.promoPrice}
                                        type="number" step="any" min="0" name="maximumPromoPrice" id="templatemaximumPromoPrice" placeholder="$ Maximum Price"
                                        value={this.state.input.maximumPromoPrice} onChange={(e) => this.handleChange(e, true)} required />
                                    <FormFeedback>Maximum Price must be higher than the default Price</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templateCycle">Default Promotion Cycle *</Label>
                                    <Input type="number" step="any" name="cycle" id="templatePrice" placeholder="Cycle" value={this.state.input.cycle} onChange={(e) => this.handleChange(e, true)} required />
                                </FormGroup>
                            </Col>

                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templateminCycle">Minimum Cycle *</Label>
                                    <Input
                                        valid={this.state.input.cycle && this.state.input.minCycle && this.state.input.minCycle < this.state.input.cycle}
                                        invalid={this.state.input.cycle && this.state.input.minCycle && this.state.input.minCycle > this.state.input.cycle}
                                        type="number" step="any" name="minCycle" id="templateminCycle" placeholder="Minimum Cycle"
                                        value={this.state.input.minCycle} onChange={(e) => this.handleChange(e, true)} required />
                                    <FormFeedback>Minimum Cycle must be less than the default Cycle</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templatemaxCycle">Maximum Cycle *</Label>
                                    <Input
                                        valid={this.state.input.cycle && this.state.input.maxCycle && this.state.input.maxCycle > this.state.input.cycle}
                                        invalid={this.state.input.cycle && this.state.input.maxCycle && this.state.input.maxCycle < this.state.input.cycle}
                                        type="number" step="any" name="maxCycle" id="templatemaxCycle" placeholder="Maximum Cycle"
                                        value={this.state.input.maxCycle} onChange={(e) => this.handleChange(e, true)} required />
                                    <FormFeedback>Maximum Cycle must be higher than the default Cycle</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <Label for="templateInterval">Interval *</Label>
                                    <Input type="number" name="interval" id="templateInterval" placeholder="Interval" min="1" max="9" value={this.state.input.interval} onChange={(e) => this.handleChange(e)} required />
                                </FormGroup>
                            </Col>
                            <Col xs={4}><FormGroup>
                                <Label for="templateIntervalUnit">Interval Unit *</Label>
                                <Select
                                    className="bos-custom-select"
                                    classNamePrefix="bos-select"
                                    options={IntervalOptions}
                                    value={IntervalOptions.find(option => option.value === this.state.input.intervalUnit)}
                                    onChange={(intervalUnit) => this.setState({ input: { ...this.state.input, intervalUnit: intervalUnit.value } })}
                                    placeholder="Select Interval Unit"
                                />
                            </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label for="carModel">Car Model *</Label>
                                    <Select
                                        className="bos-custom-select"
                                        classNamePrefix="bos-select"
                                        isLoading={!(this.props.allCarModels && this.props.allCarModels.edges && this.props.allCarModels.edges.length > 0)}
                                        options={this.props.allCarModels && this.props.allCarModels.edges.length > 0 && this.props.allCarModels.edges.filter(item => item.node.make && item.node.name).map((item) => ({
                                            value: item.node.id, label: toTitleCase(item.node.make) + " " + item.node.name + (item.node.series ? " | " + item.node.series : "") + (item.node.groupType ? " | " + item.node.groupType.name : " | No Group Selected")
                                        }))}
                                        isMulti
                                        placeholder="Select Model" onChange={(carModel) => this.setState({ input: { ...this.state.input, carModels: carModel && carModel.length > 0 ? carModel.map(model => model.value) : null } })} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label for="agreementType">Agreement Type *</Label>
                                    <Select
                                        className="bos-custom-select"
                                        classNamePrefix="bos-select"
                                        isLoading={!(this.props.allAgreementTypes && this.props.allAgreementTypes.edges && this.props.allAgreementTypes.edges.length > 0)}
                                        options={this.props.allAgreementTypes && this.props.allAgreementTypes.edges.length > 0 && this.props.allAgreementTypes.edges.map((item) => ({ value: item.node.id, label: item.node.name }))}
                                        placeholder="Select Agreement Type"
                                        onChange={(agreementType) => this.setState({ input: { ...this.state.input, agreementType: agreementType && agreementType.value ? agreementType.value : null } })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="carYearMin">Car Year Min</Label>
                                    <Input type="number" name="carYearMin" id="carYearMin" placeholder="Car Year Minimum" min={2000} max={3000} value={this.state.input.carYearMin} onChange={(e) => this.handleChange(e)} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="carYearMax">Car Year Max</Label>
                                    <Input type="number" name="carYearMax" id="carYearMax" placeholder="Car Year Maximum" min={this.state.input.carYearMin ? this.state.input.carYearMin : 2000} max={3000} value={this.state.input.carYearMax} onChange={(e) => this.handleChange(e)} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="startDate">Start Date *</Label>
                                    <Input name="startDate" placeholder="Start Date" type="date" min={moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={(e) => this.handleChange(e)} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="expirationDate">Expiration Date *</Label>
                                    <Input name="expirationDate" placeholder="Expiration Date" type="date" min={moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={(e) => this.handleChange(e)} required />
                                    <Label for="expirationDate"><b>Expiration Date can only Be Sunday!</b></Label>{" "}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label for="tagNames">Add tags by name (comma separated)</Label>
                                    <Input type="text" name="tagNames" id="tagNames" placeholder="promo, two week off" value={this.state.input.tagNames} onChange={(e) => this.handleChange(e)} />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>
                                        Visible to Customers&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Input name='visibleToCustomers' placeholder="Visible To Customers" type="checkbox" onChange={(e) => this.handleChange(e)} />
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <br />
                        <ModalFooter>
                            <FormGroup check>
                                <Label check>
                                    <Input name='createAnother' type="checkbox" onChange={(e) => this.setState({ createAnother: e.target.checked })} />
                                    {" "}
                                    Create another
                                </Label>
                            </FormGroup>
                            <Button color="primary" type="submit">Create Promo</Button>
                            <Button color="secondary" onClick={() => this.props.toggleModal()}>Close</Button>
                        </ModalFooter>
                    </Form>
                </ModalBody>
            </Modal >
        )
    }
}

export default graphql(AllCarModels, {
    options: { fetchPolicy: "network-only" },
    props: ({ data }) => {
        if (!data) {
            console.error('AllCarModels data is undefined')
            return { loading: true, allCarModels: [] }
        }
        const { loading, allCarModels } = data
        return { loading, allCarModels }
    }
})(
    graphql(AllAgreementTypes, {
        options: { fetchPolicy: "network-only" },
        props: ({ data }) => {
            if (!data) {
                console.error('AllAgreementTypes data is undefined')
                return { loading: true, allAgreementTypes: [] }
            }
            const { loading, allAgreementTypes } = data
            return { loading, allAgreementTypes }
        }
    })(withApolloClient(
        AddPromotionModal)
    )
);

